import {
  View,
  Text,
  StyleSheet,
  Image,
  TouchableOpacity,
  TextInput,
  ActivityIndicator,
  FlatList,
  Modal,
  ScrollView,
  KeyboardAvoidingView,
  Platform,
  Dimensions,
  PixelRatio,
} from "react-native";
import React, { useEffect, useRef, useState } from "react";
import TopHeaderComponent from "../aTopHeader/TopHeaderComponent";
import Colours from "../../utils/Colours";
import SearchIcon from "../../icons/SearchIcon";
import MoneyIcon from "../../icons/MoneyIcon";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import BankList from "../wallet/BankList";
import ConfirmTransfer from "../wallet/ConfirmTransfer";
import Toast from "react-native-toast-message";
import toastConfig from "../../toasts/toastConfig";
import ErrorAlertComp from "../../alertComp/ErrorAlertComp";
import { useQuery } from "@tanstack/react-query";
import useAuth from "../../hooks/useAuth";
import AppTextInput from "../../utils/ColourThemes/AppTextInput";
import { useRoute } from "@react-navigation/native";
import { SafeAreaView } from "react-native-safe-area-context";
import { useNavigation } from "expo-router";

const { width, height } = Dimensions.get("window");
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const TransferFromTable = ({
  useCaption,
  tableToUseID,
  useContributionAmount,
  scrollToTop,
  showConfirmTransfer,
  setShowConfirmTransfer,
  showPaymentReceipt,
  setShowPaymentReceipt,
  hideAllPayScreens,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  //  const [isLoading1, setIsLoading1] = useState(false)
  const [isLoading2, setIsLoading2] = useState(false);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [selectedBankName, setSelectedBankName] = useState("");
  const [selectedBankCode, setSelectedBankCode] = useState("");
  const [billingAddress, setBillingAddress] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [transferAmt, setTransferAmt] = useState("");
  const [transfer_source, setTransfer_Source] = useState("");
  const [reason, setReason] = useState("");
  //  const [bankData, setBankData] = useState([])
  // const { data: bankData, isLoading1, error } = useGetAllBanks();

  const [isFormAccNoClicked, setIsFormAccNoClicked] = useState(false);
  const [isBillingAddClicked, setIsBillingAddClicked] = useState(false);
  const [isFormSelectBankClicked, setIsFormSelectBankClicked] = useState(false);
  const [isFormEnterAmountClicked, setIsFormEnterAmountClicked] = useState(false);
  const [isFormReasonClicked, setIsFormReasonClicked] = useState(false);
  const [isErrorCompVisible, setIsErrorCompVisible] = useState(false);
  const [transactionCharge, setTransactionCharges] = useState("");

  const [errorMessage, setErrorMessage] = useState("");

  const [showPickerItems, setShowPickerItems] = useState(false);

  // const [showConfirmTransfer, setShowConfirmTransfer] = useState(false)

  const [isVisible, setIsVisible] = useState(false);
  const [account_name, setAccount_name] = useState();

  const [transferRecipientDetails, setTransferRecipientDetails] = useState();

  // const { firstname } = useAuth()
  // const [reasons, setReasons] = useState(`${firstname}_`)

  const { firstname, lastname } = useAuth();
  const [reasons, setReasons] = useState(
    `${firstname?.toUpperCase() || ""} ${lastname?.toUpperCase() || ""}_`,
  );
  const [transferReason, setTransferReason] = useState("");

  const axiosPrivate = useAxiosPrivate();
  const route = useRoute();
  const { tableData } = route.params;
  const navigation = useNavigation();

  console.log("tableDatdhd", tableData);

  useEffect(() => {
    const transferSource = tableData ? "table" : "meezaCredit";
    //console.log('transferSource', transferSource)

    //console.log('firstname', firstname)

    setTransfer_Source(transferSource);
  }, [tableData, firstname]);

  // Fetch all existing charge settings
  useEffect(() => {
    const fetchCharges = async () => {
      try {
        const res = await axiosPrivate.get("/getAllCharges/getAllCharges");
        if (res.data && res.data.length > 0) {
          setTransactionCharges(res.data[0]);
        }
      } catch (err) {
        //console.error('Error fetching charges:', err);
      }
    };
    fetchCharges();
  }, []);

  const calculateServiceCharge = (amount, chargeData) => {
    let serviceCharge = 0;
    let vat = 0;

    if (amount > chargeData.threshold1) {
      serviceCharge = chargeData.Charges1.price;
      vat = chargeData.Charges1.tax;
    } else if (amount > chargeData.threshold4 && amount <= chargeData.threshold1) {
      serviceCharge = chargeData.Charges2.price;
      vat = chargeData.Charges2.tax;
    } else if (amount <= chargeData.threshold4) {
      serviceCharge = chargeData.Charges3.price;
      vat = chargeData.Charges3.tax;
    }

    return { serviceCharge, vat };
  };

  const handleProceedWithTransfer = () => {
    //Check account number, acc name, bankName,amount
    //before submitting
    if (selectedBankName === "") {
      setIsFormSelectBankClicked(true);
    } else if (accountNumber === "") {
      setIsFormAccNoClicked(true);
    } else if (account_name === "") {
      //console.log('account name not found')
    } else if (transferAmt === "" || Number(transferAmt.replace(/,/g, "")) === 0) {
      setIsFormEnterAmountClicked(true);
    } else {
      setIsButtonClicked(true);
      //console.log('All conditions have been met')
      //console.log('transferAmt', transferAmt)
      const rawAmount = Number(transferAmt.toString().replace(/,/g, ""));
      const amount = rawAmount;
      //console.log('amount', amount)
      //console.log('rawAmount', rawAmount)
      const { serviceCharge, vat } = calculateServiceCharge(amount, transactionCharge);
      //send to the database to generate recipient_code
      createTransferRecipient(serviceCharge, vat);
    }
  };

  const createTransferRecipient = async (serviceCharge, vat) => {
    // const rawAmt = Number(transferAmt.toString().replace(/,/g, ''));
    const bankCode = selectedBankCode;
    const chargesx = (serviceCharge + vat).toFixed(2);
    const amount = transferAmt;
    const tableID = tableData.tableToUseID;

    //console.log('serviceCharge', serviceCharge)
    //console.log('vat', vat)
    //console.log('transferAmt', transferAmt)
    //console.log('Newamount', amount)

    setIsLoading2(true);

    try {
      const response = await axiosPrivate.post("/transfer/recipient", {
        account_name,
        accountNumber,
        bankCode,
        reason: reasons,
        transferReason,
        amount,
        chargesx,
        billingAddress,
        transfer_source,
        tableID,
      });
      if (response.status === 200 && response.data?.data) {
        //console.log('Transaction Recipient:', response.data.data)
        setTransferRecipientDetails(response.data.data);
        // setShowConfirmTransfer(true);
        navigation.navigate("", {
          transferRecipientDetails,
          transfer_source,
          tableData, //tableData._id
          billingAddress,
          selectedBankCode,
        });
      }
    } catch (error) {
      if (error.response) {
        //  //console.error('Server Error:', error.response.status, error.response.data);
        setIsErrorCompVisible(true);
        setErrorMessage(
          error.response.data.message ? error.response.data.message : error.response.status,
        );
      } else if (error.request) {
        //  //console.error('Network Error:', error.request);
        setIsErrorCompVisible(true);
        setErrorMessage("Network error please check your internet");
      } else {
        //  //console.error('Error:', error.message);
        setIsErrorCompVisible(true);
        setErrorMessage(error.message);
      }
    } finally {
      setIsLoading2(false);
    }
  };

  const handleOnEnterAmount = (text) => {
    setTransferAmt(text.toLocaleString());
    //console.log('text', text)
  };

  const handleSelectBank = (bankName, bankCode) => {
    //console.log('bankName', bankName)
    //console.log('bankCode', bankCode)
    setSelectedBankName(bankName);
    setSelectedBankCode(bankCode);
    setShowPickerItems(false);
  };

  const handleReason = (text) => {
    setTransferReason(text);
  };
  const handleBillingAddress = (text) => {
    setBillingAddress(text);
  };

  const handleAccountNumber = (text) => {
    setAccountNumber(text);

    if (text.length === 10) {
      resolveAccount(text); // Call resolveAccount when the length is 10
    }
  };
  const fetchBanks = async () => {
    //  setIsLoading1(true)
    try {
      const response = await axiosPrivate.get("/getBanks");
      if (response.data && response.data.banks) {
        //console.log('Banks:', response.data.banks);
        return response.data.banks; // Return bank data
      }
      throw new Error("No banks found"); // Handle unexpected response
    } catch (error) {
      if (error.response) {
        Toast.show({
          type: "error",
          text1: "Server Error!!",
          text2: error.response.data?.message || "Server Error",
        });
      } else if (error.request) {
        Toast.show({
          type: "error",
          text1: "Network Error!!",
          text2: "Network Error. Please check your Internet.",
        });
      } else {
        Toast.show({
          type: "error",
          text1: "Error!!",
          text2: error.message || "Unexpected Error",
        });
      }
    } finally {
      //   setIsLoading1(false)
    }
  };

  const {
    data: bankData,
    isLoading: isLoading1,
    error: bankDataError,
  } = useQuery({
    queryKey: ["banks"], // Unique key for caching
    queryFn: fetchBanks,
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });

  // const getAllBanks = async () => {
  //     setIsLoading1(true)
  //     try {
  //         // if (accountNumber === '') {
  //         //     setIsFormAccNoClicked(true)
  //         // } else {
  //         const response = await axiosPrivate.get('/getBanks')
  //         if (response.data && response.data.banks) {
  //             //console.log('Banks:', response.data.banks)
  //             setBankData(response.data.banks)
  //             setShowPickerItems(true)
  //         }
  //         // }

  //     } catch (error) {
  //         // Check if error response is available
  //         if (error.response) {
  //             // Server returned a response (e.g., 4xx or 5xx status)
  //             //console.error('Server Error:', error.response.status, error.response.data);
  //         } else if (error.request) {
  //             // No response received
  //             //console.error('Network Error:', error.request);
  //         } else {
  //             // Error setting up the request
  //             //console.error('Error:', error.message);
  //         }
  //     } finally {
  //         setIsLoading1(false)
  //     }
  // }
  const getAllBanks = () => {
    setShowPickerItems(true);
  };

  const resolveAccount = async (accountNumber) => {
    const bankCode = selectedBankCode;
    //console.log('accountNumber', accountNumber)
    //console.log('Bank Code', bankCode)

    try {
      setIsLoading(true);
      const response = await axiosPrivate.get(`/verify/resolve-account`, {
        params: { accountNumber, bankCode },
      });

      if (response.status === 200 && response.data?.data) {
        //console.log('Resolved Account Data:', response.data.data);
        setAccount_name(response.data.data.account_name);
        setIsVisible(true);
      } else {
        //console.warn('No data returned from resolve account API');
      }
    } catch (error) {
      // //console.error('Error resolving account:', error.response?.data || error.message);
      Toast.show({
        type: "error",
        text1: "Error resolving account",
        text2: "Bank name or account is incorrect",
      });
      // Trigger the scroll to top in the parent
      if (scrollToTop) {
        scrollToTop();
      }
    } finally {
      setIsLoading(false);
    }
  };

  // const handleAccountNumber = (text) => {
  //     setAccountNumber(text)
  // }

  return (
    <SafeAreaView>
      <TopHeaderComponent
        headerText={"Transfer From Table"}
        hideScreen={() => navigation.goBack()}
      />
      <ScrollView
        contentContainerStyle={{
          flexGrow: 1,
          height: "100%",
          paddingBottom: 1,
          backgroundColor: Colours.LIGHTEST,
        }}
      >
        {/* <KeyboardAvoidingView
                style={{ flex: 1 }}
                behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
            > */}

        {tableData ? (
          <View style={styles.paymentMethodStyle}>
            <Text style={styles.useCaptionTxt}>{tableData.tableCaption}</Text>
            <View
              style={styles.dataContainer2}
              // onPress={() => setShowConfirmTransfer(true)}//Remove this in production
            >
              <View style={styles.dataSubContainer}>
                <MoneyIcon
                  color={Colours.PRIMARY_LIGHT}
                  height={dynamicSize(30)}
                  width={dynamicSize(30)}
                />
                <View style={styles.captionAndDescribtion}>
                  <View style={styles.flatArrowContainer}>
                    <Text style={styles.moneyOnTableTxt}>Money on the table: </Text>
                    <Text style={styles.moneyOnTableAmtTxt}>
                      {tableData.totalContributionsAmount}{" "}
                    </Text>
                    {/* <FowardFlatArrow color={Colours.PRIMARY} /> */}
                  </View>
                </View>
              </View>
            </View>
          </View>
        ) : (
          ""
        )}

        <View style={styles.textboxAmountContainer}>
          <View style={styles.textboxHeader}>
            <Text style={styles.beneficiaryTxt}>Beneficiary Details </Text>
            <Text style={styles.beneficiaryDemacationTxt}>|:</Text>
          </View>
          <View style={styles.textBoxContainer}>
            <TouchableOpacity
              style={[
                styles.inputTxt1,
                isFormSelectBankClicked && styles.focusedBorder,
                //{ borderColor: isFormContainerClicked ? Colours.PRIMARY : Colours.LIGHTGRAY },
              ]}
              onPress={getAllBanks}
              onPressIn={() => setIsFormSelectBankClicked(true)}
              onPressOut={() => setIsFormSelectBankClicked(false)}
            >
              {isLoading1 ? (
                <ActivityIndicator size="small" color={Colours.PRIMARY} />
              ) : selectedBankName ? (
                <Text style={styles.selectedBankNameTxt}>{selectedBankName}</Text>
              ) : (
                <Text style={styles.selectedBankTxt}>Select Bank</Text>
              )}
            </TouchableOpacity>

            <AppTextInput
              style={[
                styles.inputTxt,
                isFormAccNoClicked && styles.focusedBorder,
                //{ borderColor: isFormContainerClicked ? Colours.PRIMARY : Colours.LIGHTGRAY },
              ]}
              placeholder="Beneficiary account no."
              keyboardType="numeric"
              onFocus={() => setIsFormAccNoClicked(true)}
              onBlur={() => setIsFormAccNoClicked(false)}
              onChangeText={handleAccountNumber}
            />

            {isLoading ? (
              <View style={styles.loaderContainer}>
                <ActivityIndicator size="small" color={Colours.PRIMARY} />
              </View>
            ) : (
              isVisible && (
                <TouchableOpacity style={styles.inputTxt3}>
                  <Text style={styles.accountNameTxt}>
                    {account_name ? account_name : "No name found"}
                  </Text>
                </TouchableOpacity>
              )
            )}

            <AppTextInput
              style={[
                styles.inputTxt,
                isFormEnterAmountClicked && styles.focusedBorder,
                //{ borderColor: isFormContainerClicked ? Colours.PRIMARY : Colours.LIGHTGRAY },
              ]}
              placeholder="Enter Amount"
              keyboardType="numeric"
              onFocus={() => setIsFormEnterAmountClicked(true)}
              onBlur={() => setIsFormEnterAmountClicked(false)}
              value={transferAmt}
              onChangeText={(text) => {
                const numericValue = Number(text.replace(/\D/g, ""));
                const formattedValue = numericValue.toLocaleString();
                handleOnEnterAmount(formattedValue);
              }}
            />
            {/* {tableData ? (
              <>
                <TouchableOpacity style={styles.inputTxt33}>
                  <Text style={styles.billingAddress}>Where table money is being spent</Text>

                  <AppTextInput
                    style={[
                      styles.inputTxt,
                      isBillingAddClicked && styles.focusedBorder,
                      //{ borderColor: isFormContainerClicked ? Colours.PRIMARY : Colours.LIGHTGRAY },
                    ]}
                    placeholder="Billng Address."
                    onFocus={() => setIsBillingAddClicked(true)}
                    onBlur={() => setIsBillingAddClicked(false)}
                    onChangeText={handleBillingAddress}
                  />
                </TouchableOpacity>
              </>
            ) : (
              ""
            )} */}
            <AppTextInput
              style={[
                styles.textDescInputStyle,
                isFormReasonClicked && styles.focusedBorder,
                //{ borderColor: isFormContainerClicked ? Colours.PRIMARY : Colours.LIGHTGRAY },
              ]}
              placeholder="Reason"
              numberOfLines={3}
              multiline
              onFocus={() => setIsFormReasonClicked(true)}
              onBlur={() => setIsFormReasonClicked(false)}
              onChangeText={handleReason}
            />
          </View>
          <TouchableOpacity
            style={[
              styles.buttonGray,
              {
                backgroundColor: isButtonClicked ? Colours.PRIMARY : Colours.LIGHTGRAY,
              },
            ]}
            onPress={() => handleProceedWithTransfer()}
            disabled={isLoading2}
          >
            {isLoading2 ? (
              <ActivityIndicator size="small" color="white" />
            ) : (
              <Text
                style={{
                  color: isButtonClicked ? "white" : Colours.DARKGRAY,
                  fontSize: dynamicSize(15),
                  fontFamily: "Sen-Bold",
                }}
              >
                Proceed
              </Text>
            )}
          </TouchableOpacity>
        </View>
      </ScrollView>

      {/* </KeyboardAvoidingView> */}

      <Modal
        AnimationType="fade"
        visible={showPickerItems}
        onRequestClose={() => setShowPickerItems(false)}
      >
        <BankList
          bankData={bankData}
          handleSelectBank={handleSelectBank}
          setShowPickerItems={setShowPickerItems}
        />
        {/* </ScrollView> */}
      </Modal>
      {/* 
      <Modal
        AnimationType="fade"
        visible={showConfirmTransfer}
        onRequestClose={() => setShowConfirmTransfer(false)}
      >
        <TopHeaderComponent
          headerText={"Confirm Transfer"}
          hideScreen={() => setShowConfirmTransfer(false)}
        />
        <ScrollView
          contentContainerStyle={{
            flexGrow: 1,
            paddingBottom: 100,
            backgroundColor: Colours.LIGHTEST,
          }}
        >
          <View style={styles.componentStyle}>
            {transferRecipientDetails && (
              <ConfirmTransfer
                transferRecipientDetails={transferRecipientDetails}
                transfer_source={transfer_source}
                tableToUseID={tableData.tableToUseID}
                billingAddress={billingAddress}
                selectedBankCode={selectedBankCode}
                showPaymentReceipt={showPaymentReceipt}
                setShowPaymentReceipt={setShowPaymentReceipt}
                hideAllPayScreens={hideAllPayScreens}
              />
            )}
          </View>
        </ScrollView>
      </Modal> */}
      <Modal
        visible={isErrorCompVisible}
        transparent={true}
        animationType="fade"
        onRequestClose={() => setIsErrorCompVisible(false)}
      >
        <ErrorAlertComp message={errorMessage} onClose={() => setIsErrorCompVisible(false)} />
      </Modal>
      <Toast config={toastConfig} />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  paymentMethodStyle: {
    display: "flex",
    justifyContent: "center",
    margin: dynamicSpacing(15),
    marginBottom: dynamicSpacing(4),
    padding: dynamicSpacing(15),
    borderRadius: dynamicSize(15),
    backgroundColor: "white",
    shadowColor: "#E8E8E8",
  },
  useCaptionTxt: {
    marginBottom: dynamicSpacing(10),
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(16),
    fontFamily: "Sen-Bold",
  },
  moneyOnTableTxt: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(14),
    fontFamily: "Sen-Regular",
  },
  moneyOnTableAmtTxt: {
    color: Colours.PRIMARY,
    fontSize: dynamicFontSize(18),
    fontFamily: "Sen-Bold",
  },
  beneficiaryTxt: {
    marginTop: dynamicSpacing(10),
    marginBottom: dynamicSpacing(10),
    fontSize: dynamicFontSize(15),
    color: Colours.DARKGRAY,
    fontFamily: "Sen-Regular",
  },
  beneficiaryDemacationTxt: {
    paddingLeft: dynamicSpacing(1),
    paddingBottom: 0,
    color: Colours.PRIMARY_LIGHT,
    fontFamily: "Sen-Regular",
  },
  selectedBankNameTxt: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Regular",
  },
  selectedBankTxt: {
    color: Colours.DARKLIGHTGRAY,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Regular",
  },
  accountNameTxt: {
    color: "white",
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Regular",
    textAlign: "center",
  },
  billingAddress: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Regular",
    // padding: dynamicSpacing(10)
  },
  dataContainer2: {
    display: "flex",
    borderWidth: dynamicSpacing(1),
    borderColor: Colours.PRIMARY_LIGHTER,
    padding: dynamicSpacing(15),
    borderRadius: dynamicSize(10),
    marginBottom: dynamicSpacing(10),
  },
  dataContainer: {
    display: "flex",
    backgroundColor: "white",
    margin: dynamicSpacing(10),
    marginTop: dynamicSpacing(15),
    padding: dynamicSpacing(15),
    borderRadius: dynamicSize(10),
    marginBottom: dynamicSpacing(10),
  },
  dataSubContainer2: {
    display: "flex",
    flexDirection: "row",
    gap: dynamicSpacing(10),
    alignItems: "center",
    marginBottom: dynamicSpacing(10),
  },
  dataSubContainer: {
    display: "flex",
    flexDirection: "row",
    gap: dynamicSpacing(10),
    alignItems: "center",
  },
  flatArrowContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  textDescInputStyle: {
    height: dynamicSpacing(70),
    marginTop: dynamicSpacing(10),
    padding: dynamicSpacing(15),
    borderWidth: dynamicSpacing(3),
    borderColor: Colours.LIGHTGRAY,
    borderRadius: dynamicSize(10),
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(15),
    verticalAlign: "top",
    backgroundColor: Colours.LIGHTGRAY,
  },
  componentStyle: {
    backgroundColor: Colours.LIGHTEST,
    height: "100%",
  },
  loaderContainer: {
    padding: dynamicSpacing(10),
  },
  textboxAmountContainer: {
    margin: dynamicSpacing(15),
    marginTop: dynamicSpacing(15),
    marginBottom: dynamicSpacing(40),
    padding: dynamicSpacing(15),
    borderRadius: dynamicSize(15),
    backgroundColor: "white",
    shadowColor: "#E8E8E8",
  },
  textboxAmountContainer2: {
    margin: dynamicSpacing(15),
    marginTop: 0,
    marginBottom: 0,
    padding: dynamicSpacing(15),
    paddingTop: 0,
    borderRadius: dynamicSize(15),
    backgroundColor: "white",
    shadowColor: "#E8E8E8",
  },
  textboxAmountContainer3: {
    margin: dynamicSpacing(15),
    marginTop: 0,
    padding: dynamicSpacing(15),
    borderRadius: dynamicSize(15),
    backgroundColor: "white",
    shadowColor: "#E8E8E8",
  },
  textboxHeader: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: dynamicSpacing(1),
  },
  textBoxContainer: {
    display: "flex",
    marginBottom: dynamicSpacing(20),
  },
  focusedBorder: {
    borderColor: Colours.PRIMARY,
    borderWidth: dynamicSpacing(2),
  },
  inputTxt: {
    height: dynamicSpacing(40),
    marginTop: dynamicSpacing(10),
    padding: dynamicSpacing(10),
    borderWidth: dynamicSpacing(2.5),
    borderColor: Colours.LIGHTGRAY,
    borderRadius: dynamicSize(7),
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(15),
    backgroundColor: Colours.LIGHTGRAY,
  },
  inputTxt1: {
    height: dynamicSpacing(40),
    marginTop: dynamicSpacing(10),
    padding: dynamicSpacing(10),
    borderWidth: dynamicSpacing(2.5),
    borderColor: Colours.LIGHTGRAY,
    borderRadius: dynamicSize(7),
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(15),
    backgroundColor: Colours.LIGHTGRAY,
  },
  inputTxt3: {
    marginTop: dynamicSpacing(10),
    padding: dynamicSpacing(10),
    borderRadius: dynamicSize(7),
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(15),
    backgroundColor: Colours.PRIMARY_LIGHT,
  },
  inputTxt33: {
    display: "flex",
    marginTop: dynamicSpacing(10),
    padding: dynamicSpacing(7),
    borderRadius: dynamicSize(7),
    fontFamily: "Sen-Regular",
    fontSize: dynamicFontSize(15),
    backgroundColor: Colours.PRIMARY_LIGHTER,
  },

  tableAmountContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: dynamicSpacing(5),
    marginBottom: dynamicSpacing(10),
  },
  buttonGray: {
    display: "flex",
    borderRadius: dynamicSize(10),
    justifyContent: "center",
    marginTop: "15%",
    alignItems: "center",
    height: dynamicSpacing(55),
    backgroundColor: Colours.DARKGRAY,
  },
});

export default TransferFromTable;
